
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-5d90d667&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./FYOpeningBalance.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./FYOpeningBalance.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-5d90d667!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./FYOpeningBalance.vue"),
  /* scopeId */
  "data-v-5d90d667",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/microfinance/accounting/FYOpeningBalance.vue
// module id = 746
// module chunks = 0